<mat-sidenav-container
  hasBackdrop="true"
  class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0"
>
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>

          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>Bloques de numeración para los documentos. 
                Indica del n° inicial al n° final, con vigencia.
                Úsalo para controlar correlativos por punto de emisión
                y tipo de documento.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Rangos
          </h2>
          </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          En base a la <b>clase de documento</b> y el <b>punto de emisión</b> se configura cada documento en base a la <b>ruta</b>.
        </div>
      </div>
      <!-- Header -->
      <div
        class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between"
      >
        <div class="flex shrink-0">
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">
            Rango de Documentos
          </div> -->
          <app-status-filters [selectedStatuses]="selectedStatuses" [showStatus]="[1,0]" [typeFilter]="'master'"
            (selectionFilterApply)="findAllWithCount()">
          </app-status-filters>
        </div>     
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">

          <mat-slide-toggle style="margin-top: 0.7em; margin-right: 2em;" color="primary" [(ngModel)]="modeTree" (click)="onChangeEmissionPointTree()">
            Modo Árbol
          </mat-slide-toggle>

          <button class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'" (click)="onExportButtonPressed()" matTooltip="Exportar">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
            <span class="ml-2">Exportar</span>
          </button>
          
          <!-- Add button (only icon) -->
          <button
            mat-icon-button
            color="primary"
            (click)="openModal()"
            matTooltip="Nuevo registro de rango de documentos"
          >
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        
        <!-- Main Content (Table and Paginator) -->
        <div *ngIf="!modeTree" class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Tabla -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent"
                mat-table
                [dataSource]="dataSource"
                matSort
                [trackBy]="trackByFn"
              >
                <!-- Nombre -->
                <!-- <ng-container matColumnDef="code">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                  >
                    Código
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let range"
                    class="pl-10 text-left uppercase"
                  >
                    {{ range.code }}
                  </td>
                </ng-container> -->

                <ng-container matColumnDef="code">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                  >
                    Punto de Emisión
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let range"
                    class="text-sm uppercase leading-tight"
                  >
                  <!-- <div *ngIf="range?.code">
                    <b style="font-size: 12px;">{{ range?.code }}</b>
                  </div> -->
                  <div>
                    <b class="f-10">{{range.code}}</b>
                  </div>
                    {{ range?.emissionPoint?.name }}
                  <div>
                    <span style="font-size: 10px; color: #6b7280;"><strong>{{ generateExampleColumnsFormat(range) }}</strong></span>
                  </div>
                  </td>
                </ng-container>

                <!-- Tipo de Documento -->
                <ng-container matColumnDef="documentType">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo de Doc. </th>
                  <td mat-cell *matCellDef="let element" class="text-sm uppercase leading-tight">
                      <b class="f-10">{{element.documentType?.code}}</b><br>
                      {{ element.documentType?.name }}</td>
                </ng-container>

                <!-- Clase de Documento -->
                <ng-container matColumnDef="documentClass">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Clase de Doc. </th>
                  <td mat-cell *matCellDef="let element" class="text-sm uppercase leading-tight">
                      <b class="f-10">{{element.documentClass?.code}}</b><br>
                      {{ element.documentClass?.name }}</td>
                </ng-container>

                <!-- Fecha de Caducidad -->
                <ng-container matColumnDef="dateEnd">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha de Caducidad</th>
                  <td mat-cell *matCellDef="let element" class="px-6 text-center text-sm uppercase">
                      {{ element?.dateTimeEnd | FormatDateHour: false }}</td>
                </ng-container>

                <!-- Clase de Documento -->
                <ng-container matColumnDef="upperLimit">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Límite Superior</th>
                  <td mat-cell *matCellDef="let element" class="px-6 text-center text-sm uppercase">
                      {{ element?.upperLimit }}</td>
                </ng-container>

                <!-- Clase de Documento -->
                <ng-container matColumnDef="currentValue">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Valor Actual</th>
                  <td mat-cell *matCellDef="let element" class="px-6 text-center text-sm uppercase">
                      {{ element?.currentValue }}</td>
                </ng-container>

                <!-- Estado -->
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef>
                    Estado
                  </th>
                  <td mat-cell *matCellDef="let range">
                    <mat-slide-toggle
                      class="custom-slide-toggle primary"
                      [checked]="range.statusId == 1"
                      [(ngModel)]="range.statusId"
                      [color]="'success'"
                      (ngModelChange)="onStatusChange($event, range)"
                    >
                    </mat-slide-toggle>
                  </td>
                </ng-container>

                <!-- Acciones -->
                <ng-container matColumnDef="actions">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="px-6 py-3 text-left"
                  ></th>
                  <td mat-cell *matCellDef="let range" class="px-6 py-3 text-left">
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="actionMenu"
                      matTooltip="Acciones"
                    >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #actionMenu="matMenu">
                      <button mat-menu-item (click)="openModal(range)">
                        <mat-icon
                          svgIcon="heroicons_outline:pencil-square"
                        ></mat-icon>
                        <span>Editar Registro</span>
                      </button>
                      <button mat-menu-item (click)="openDeleteDialog(range)">
                        <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                        <span>Eliminar Registro</span>
                      </button>
                    </mat-menu>
                  </td>
                </ng-container>

                <!-- Header Row -->
                <tr
                  mat-header-row
                  *matHeaderRowDef="displayedColumns"
                  class="sticky top-0 z-10  bg-white dark:bg-gray-900"
                ></tr>

                <!-- Fila principal -->
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"
                  class="border-b"
                ></tr>
            </table>
          </div>

          <!-- Paginación -->
          <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
            <mat-paginator
              class="z-10"
              [pageSizeOptions]="[50, 100, 150, 200]"
              showFirstLastButtons
              [length]="totalItems"
              [pageSize]="pageSize"
              (page)="onPageChange($event)"
            ></mat-paginator>
          </div>
        </div>

        <!-- Tabla -->
        <div  *ngIf="modeTree" class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent"
              mat-table
              [dataSource]="dataSourceTree"
              matSort
              [trackBy]="trackByFn"
              multiTemplateDataRows
            >
              <ng-container matColumnDef="code">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                >
                  <span [style.paddingLeft.px]="30">Punto de Emisión</span>
                </th>
                <td
                  mat-cell
                  *matCellDef="let range"
                  class="text-sm uppercase leading-tight"
                >
                  <div class="flex items-center">
                    <button mat-icon-button [style.visibility]="!range?.expandable ? 'hidden' : ''"
                      [style.marginLeft.px]="range?.levelTree * 10" (click)="treeControl.toggle(range)">
                      <mat-icon color="primary" class="mat-icon-rtl-mirror">
                        {{treeControl.isExpanded(range) ? 'expand_more' : 'chevron_right'}}
                      </mat-icon>
                    </button>
                    
                    <div class="flex flex-col ml-2">
                      <div *ngIf="(!range.children || range.children.length === 0) else emissionCode">
                        <span class="f-14">{{range.code}}</span>
                      </div>
                      <ng-template #emissionCode>
                        <b>{{ range?.emissionPoint?.name }}</b>
                      </ng-template>

                      <div *ngIf="!range.children || range.children.length === 0"> 
                        <strong style="font-size: 10px; color: #6b7280;">{{ generateExampleColumnsFormat(range) }}</strong>
                      </div>
                    </div>

                  </div>
                </td>
              </ng-container>

              <!-- Tipo de Documento -->
              <ng-container matColumnDef="documentType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo de Doc. </th>
                <td mat-cell *matCellDef="let element" class="text-sm uppercase leading-tight">
                    <div *ngIf="!element.children || element.children.length === 0 else defaultRow">
                      <b class="f-10">{{element.documentType?.code}}</b><br>
                      {{ element.documentType?.name }}
                    </div>
                </td>
              </ng-container>

              <!-- Clase de Documento -->
              <ng-container matColumnDef="documentClass">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Clase de Doc. </th>
                <td mat-cell *matCellDef="let element" class="text-sm uppercase leading-tight">
                  <div *ngIf="!element.children || element.children.length === 0 else defaultRow">
                    <b class="f-10">{{element.documentClass?.code}}</b><br>
                    {{ element.documentClass?.name }}
                  </div>
                </td>
              </ng-container>

              <!-- Fecha de Caducidad -->
              <ng-container matColumnDef="dateEnd">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha de Caducidad</th>
                <td mat-cell *matCellDef="let element" class="px-6 text-center text-sm uppercase">
                  <div *ngIf="!element.children || element.children.length === 0 else defaultRow">
                    {{ element?.dateTimeEnd | FormatDateHour: false }}
                  </div>
                </td>
              </ng-container>

              <!-- Clase de Documento -->
              <ng-container matColumnDef="upperLimit">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Límite Superior</th>
                <td mat-cell *matCellDef="let element" class="px-6 text-center text-sm uppercase">
                  <div *ngIf="!element.children || element.children.length === 0 else defaultRow">
                    {{ element?.upperLimit }}
                  </div>
                </td>
              </ng-container>

              <!-- Clase de Documento -->
              <ng-container matColumnDef="currentValue">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Valor Actual</th>
                <td mat-cell *matCellDef="let element" class="px-6 text-center text-sm uppercase">
                  <div *ngIf="!element.children || element.children.length === 0 else defaultRow">
                    {{ element?.currentValue }}
                  </div>
                </td>
              </ng-container>

              <!-- Estado -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>
                  Estado
                </th>
                <td mat-cell *matCellDef="let range">
                  <div *ngIf="!range.children || range.children.length === 0">
                    <mat-slide-toggle
                      class="custom-slide-toggle primary"
                      [checked]="range.statusId == 1"
                      [(ngModel)]="range.statusId"
                      [color]="'success'"
                      (ngModelChange)="onStatusChange($event, range)"
                    >
                    </mat-slide-toggle>
                  </div>
                </td>
              </ng-container>

              <!-- Acciones -->
              <ng-container matColumnDef="actions">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="px-6 py-3 text-left"
                ></th>
                <td mat-cell *matCellDef="let range" class="px-6 py-3 text-left">
                  <div *ngIf="!range.children || range.children.length === 0">
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="actionMenu"
                      matTooltip="Acciones"
                    >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #actionMenu="matMenu">
                      <button mat-menu-item (click)="openModal(range)">
                        <mat-icon
                          svgIcon="heroicons_outline:pencil-square"
                        ></mat-icon>
                        <span>Editar Registro</span>
                      </button>
                      <button mat-menu-item (click)="openDeleteDialog(range)">
                        <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                        <span>Eliminar Registro</span>
                      </button>
                    </mat-menu>
                  </div>
                </td>
              </ng-container>

              <!-- Header Row -->
              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumnsTree"
                class="sticky top-0 z-10  bg-white dark:bg-gray-900"
              ></tr>

              <tr mat-row *matRowDef="let row; columns: displayedColumnsTree"
              [ngStyle]="{'cursor': isEditSort ? 'ns-resize' : 'null'}" class="border-b"></tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <ng-template #deleteDialog let-data>
      <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
          <mat-icon
            svgIcon="heroicons_outline:exclamation-triangle"
            class="text-red-500 ml-4 mt-6"
            style="font-size: 32px"
          ></mat-icon>
        </div>
        <div class="grid">
          <h2 mat-dialog-title class="text-lg font-bold mb-1">
            Confirmar eliminación
          </h2>
          <mat-dialog-content class="modal-content mt-0">
            <p>¿Está seguro que desea eliminar el registro?</p>
          </mat-dialog-content>
        </div>
      </div>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">
          Conservar
        </button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">
          Eliminar
        </button>
      </mat-dialog-actions>
    </ng-template>

    <ng-template #defaultRow>
      -
    </ng-template>
  </div>
  <!-- Filtros -->
  <app-filter
    (onFilterEvent)="findAllWithCount()"
    (onCleanEvent)="clearFilters()"
    (onPanelOpened)="onFilterPanelOpened()"
  >
    <app-documents-filters [form]="form" [documentClass]="true" [pointEmission]="true" [documentType]="true" [loadData]="loadFiltersData"></app-documents-filters>
  </app-filter>
</mat-sidenav-container>
